import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-24 md:py-32 px-6 md:px-12">
        <div className="container mx-auto max-w-4xl text-center">
          <div className="flex justify-center mb-8">
            <img 
              src="/logo.png" 
              alt="Die Afrikaner se Goue Kalf" 
              className="h-32 w-32 md:h-40 md:w-40 object-contain animate-fade-in"
            />
          </div>
          <h1 className="font-heading text-5xl md:text-7xl font-light tracking-tight italic text-charcoal mb-8 animate-fade-in">
            Die Afrikaner se Goue Kalf
          </h1>
          <p className="font-ui text-sm uppercase tracking-widest text-muted-charcoal mb-12">
            deur Francois Muller
          </p>
          
          <div className="prose prose-lg max-w-prose mx-auto text-charcoal font-body text-xl md:text-2xl leading-relaxed mb-16">
            <p className="mb-6">
              'n Diepgaande ondersoek na die verborge simboliek van die Voortrekker Monument, 
              Geloftedag, en Die Stem van Suid-Afrika. Hierdie werk onthul die Egiptiese, 
              Babiloniese en Vrymesselary invloede wat in ons nasionale simbole ingebed is.
            </p>
            <p>
              Deur noukeurige navorsing en Bybelse perspektief, ondersoek hierdie boek die vraag: 
              Het ons as volk onbewustelik aan afgode gebuig? Die boek bied nie 'n politieke 
              standpunt nie, maar 'n geestelike oproep tot selfondersoek en terugkeer na die 
              ware God.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/purchase"
              data-testid="cta-acquire-book"
              className="bg-charcoal text-parchment hover:bg-charcoal/80 rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300"
            >
              Skaf die Boek aan
            </Link>
            <Link
              to="/excerpts"
              data-testid="cta-read-excerpt"
              className="border border-charcoal text-charcoal hover:bg-charcoal hover:text-parchment rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300"
            >
              Lees 'n Uittreksel
            </Link>
          </div>
        </div>
      </section>

      {/* Decorative Quote Section */}
      <section className="py-24 bg-surface/30">
        <div className="container mx-auto max-w-3xl px-6 md:px-12">
          <blockquote className="font-heading text-3xl md:text-4xl font-light italic text-center text-charcoal leading-relaxed">
            "Ons het nie 'n goue kalf gemaak nie, maar ons het vele goue kalwers opgerig 
            in ons nasionale simbole. Die vraag is: sal ons buig voor hierdie afgode, 
            of sal ons terugkeer na die Lewende God?"
          </blockquote>
          <p className="text-center mt-8 font-ui text-sm uppercase tracking-widest text-muted-charcoal">
            — uit die Inleiding
          </p>
        </div>
      </section>

      {/* Introduction Cards */}
      <section className="py-24 md:py-32 px-6 md:px-12">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div data-testid="card-themes" className="bg-parchment border border-[#E5E0D6] p-8 md:p-12 hover:border-gold transition-colors duration-500">
              <h3 className="font-heading text-2xl md:text-3xl font-medium italic mb-4 text-charcoal">
                Verborge Simboliek
              </h3>
              <p className="font-body text-lg leading-loose text-muted-charcoal">
                Ontdek die Egiptiese, Babiloniese en Vrymesselary simbole in die Voortrekker Monument, 
                Die Stem, en ander nasionale ikone.
              </p>
            </div>

            <div data-testid="card-approach" className="bg-parchment border border-[#E5E0D6] p-8 md:p-12 hover:border-gold transition-colors duration-500">
              <h3 className="font-heading text-2xl md:text-3xl font-medium italic mb-4 text-charcoal">
                Bybelse Perspektief
              </h3>
              <p className="font-body text-lg leading-loose text-muted-charcoal">
                'n Gelowige ondersoek na afgodery en bul-aanbidding, met Skrifverwysings en 
                historiese konteks uit God se Woord.
              </p>
            </div>

            <div data-testid="card-purpose" className="bg-parchment border border-[#E5E0D6] p-8 md:p-12 hover:border-gold transition-colors duration-500">
              <h3 className="font-heading text-2xl md:text-3xl font-medium italic mb-4 text-charcoal">
                Geestelike Oproep
              </h3>
              <p className="font-body text-lg leading-loose text-muted-charcoal">
                'n Oproep tot bekering en terugkeer na die ware God (YHWH), weg van verborge 
                afgodediens en valse aanbidding.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
